export default __webpack_public_path__ + "static/media/7N.4318fdfd.jpg";